import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

import { formatModel, formatModels } from "../../../utils/estados";

import { SelectSearch } from "../../../components";

import { changeUser, groupedPermissions } from "../handlers";

import { changeCheckPermission, getPermissionsForm, changeUserPermissions } from "./handlers";
import CardAdmin from "../CardAdmin";
import ButtonAdmin from "../ButtonAdmin";
import AddUsers from "../AddUser";

const UserPermissionForm = ({ stateContext, dataContext, show }) => {
  const { state, setState } = stateContext;
  const { loading, role, user } = state;

  const { data, setData } = dataContext;
  const { users, permissions } = data;

  const [permissionsForm, setPermissionsForm] = useState(null);

  useEffect(() => {
    const aux = getPermissionsForm(permissions, user);
    setPermissionsForm(aux);
  }, [permissions, user]);
  const [showBuscar, setShowBuscar] = useState(false);

  const permissions_groups = groupedPermissions(permissionsForm);
  const handleUserSelect = (selectedUser) => {
    // Buscar el usuario en users->persona->usuarioID
    const foundUser = users.find((user) => {
      // Verificar si user.persona existe y no es null
      if (user.persona && user.persona.usuarioID) {
        return user.persona.usuarioID === selectedUser.id;
      }
      return false; // Si persona es null o no tiene usuarioID, retornar false
    });

    // Si se encuentra el usuario, actualizar el estado con foundUser; de lo contrario, mantener selectedUser
    setState((prev) => ({ ...prev, user: foundUser ?? selectedUser }));
    setShowBuscar(false);
  };
  const grupos = permissions_groups && Object.keys(permissions_groups);

  if (!show) return null;

  return (
    <>
      <AddUsers
        showBuscar={showBuscar}
        setShowBuscar={setShowBuscar}
        handleUserSelect={handleUserSelect}
      />
      <div className="row m-0">
        <SelectSearch
          className={{
            container: "col-6 col-lg-10",
            label: `form-label`,
          }}
          isClearable
          id="user"
          value={formatModel(user)}
          onChange={(u) => changeUser(u, users, setState)}
          disabled={loading}
          label="Seleccione un Usuario *"
          options={formatModels(data.users)}
        />

        <div className="col-6 col-lg-2 m-auto d-flex flex-column">
          <label className={`invisible form-label`}>HIDDEN</label>

          <Spinner className="mx-auto" hidden={!loading} />

          {!user?.roles?.some((r) => r.id === role?.id) && (
            <button
              hidden={loading}
              className="btn btn-primary"
              disabled={!user}
              onClick={() => changeUserPermissions(user, permissionsForm, setState, setData)}
            >
              GUARDAR
            </button>
          )}
        </div>
      </div>

      <hr className="my-3" />

      {!!user?.roles?.length && (
        <>
          {user.roles.map((r) => (
            <span key={r.id} role="button" className={`me-2 badge bg-success `}>
              {r.description}
            </span>
          ))}
          <hr className="my-3" />
        </>
      )}

      <CardAdmin
        grupos={grupos}
        permissions_groups={permissions_groups}
        loading={loading}
        changeCheckPermission={changeCheckPermission}
        permissionsForm={permissionsForm}
        setPermissionsForm={setPermissionsForm}
      />
    </>
  );
};

export default UserPermissionForm;
